import notifications, {
  toastFailure,  toastSuccess
} from '../../../global/notifications'
import {
  certificatesFetch,
  certificateClaim,
  certificateGeneralFetch,
  certificateGeneralGenerate,
  types
} from './'

// The backend answers 400 { name: [...] } when there is no name on file to
// print (SPEC-040 F8). That is the "ask for a name" signal, not an error.
const isNameMissing = (payload) =>
  payload?.status === 400 && Boolean(payload?.value?.name)

export const certificatesDispatchers = (dispatch) => ({
  loadCertificates() {
    dispatch(certificatesFetch())
  },
  claimCertificate(tutorialSlug, name) {
    return dispatch(certificateClaim({ tutorialSlug, name })).then(
      ([, res]) => {
        if (res.type === types.CERTIFICATE_CLAIM_SUCCESS)
          toastSuccess(notifications.certificateClaim)
        else
          toastFailure(notifications.certificateClaim, res.payload)
        return res
      }
    )
  },
  loadGeneralCertificate() {
    dispatch(certificateGeneralFetch())
  },
  // Omit the name to print the one on file; pass one to set (or change) it.
  // `silent` skips the success toast — used when the certificate is brought
  // up to date as part of a download, which needs no announcement.
  generateGeneralCertificate(name, { silent = false } = {}) {
    return dispatch(certificateGeneralGenerate(name ? { name } : {})).then(
      ([, res]) => {
        if (res.type === types.CERTIFICATE_GENERAL_GENERATE_SUCCESS) {
          if (!silent) toastSuccess(notifications.certificateGeneral)
        } else if (!isNameMissing(res.payload))
          toastFailure(notifications.certificateGeneral, res.payload)
        return res
      }
    )
  }
})

export default certificatesDispatchers
